export default {
  featureSwitchesState(state) {
    return state.switches;
  },
  featureSwitchesLoadedState(state) {
    return state.loaded;
  },
};
